/** Public, disposable identities used only by the isolated local auth emulator. */
export async function signInTestPlayer<T>(slot: 1 | 2, accounts: {
  register(email: string, password: string, displayName: string): Promise<T>;
  signIn(email: string, password: string): Promise<T>;
}): Promise<T> {
  if (slot !== 1 && slot !== 2) throw new Error('Choose Test Player 1 or 2.');
  const email = `local-player-${slot}@example.test`, password = 'NimbleLocalTest123!';
  try { return await accounts.register(email, password, `Test Player ${slot}`); }
  catch (error) {
    if ((error as { code?: string }).code !== 'auth/email-already-in-use') throw error;
    return accounts.signIn(email, password);
  }
}
